module.exports = __webpack_public_path__ + "img/210.hand_dryer.7f01cf32.svg";